<template>
  <div class="lounge-content-card">
    <!-- 直接点击头部benefits -->
    <div class="benefits-content-card">
      <div class="airport-service">
        <cards :options="lounge" @viewMore="handleViewMore" @cardClick="cardClick"></cards>
        <cards :options="dining" @viewMore="handleViewMore" @cardClick="cardClick"></cards>
        <cards :options="retail" @viewMore="handleViewMore" @cardClick="cardClick"></cards>
        <cards
          v-if="isLogin && benefits.cards.length > 0"
          :options="benefits"
          @viewMore="handleViewMore('visaBenefits')"
          @cardClick="goToBenefitDetail"
        ></cards>
        <cards
          v-if="isLogin && offers.cards.length > 0"
          :options="offers"
          @viewMore="handleViewMore('visaOffers')"
          @cardClick="goToOfferDetail"
        ></cards>
      </div>
    </div>
  </div>
</template>

<script>
  import Cards from '@/components/BaseUi/AirportLoungeCards';
  import { mapState } from 'vuex';

  export default {
    components: { Cards },

    computed: {
      ...mapState(['isLogin', 'userInfo']),
    },

    mounted() {
      this.getBenefitsList();
      if (this.isLogin) {
        this.getHomePageBanner({ kind: 1, type: 'offers' });
        this.getHomePageBanner({ kind: 2, type: 'benefits' });
      }
    },

    data() {
      return {
        lounge: {
          title: 'views-home-modules-lounge',
          subTitle: 'views-home-modules-lounge-more',
          showDesc2: true,
          cardHeadStyle: {
            // marginBottom: '34px',
          },
          cardItemStyle: {
            width: '25%',
          },
          cards: [],
          index: 'lounge',
        },

        dining: {
          title: 'views-home-modules-dining',
          subTitle: 'views-home-modules-dining-more',
          showDesc2: true,
          cardHeadStyle: {
            // marginBottom: '34px',
          },
          cardItemStyle: {
            width: '25%',
          },
          cards: [],
          index: 'dining',
        },

        retail: {
          title: 'views-home-modules-retail',
          subTitle: 'views-home-modules-retail-more',
          showDesc2: true,
          cardHeadStyle: {
            // marginBottom: '34px',
          },
          cardItemStyle: {
            width: '25%',
          },
          cards: [],
          index: 'retail',
        },

        benefits: {
          title: 'views-home-modules-benefits',
          subTitle: 'views-home-modules-benefits-more',
          showDesc2: true,
          // useHomePageSize: true,
          cardItemStyle: {
            width: '25%',
          },
          cards: [],
          index: 'benefit',
        },

        offers: {
          title: 'views-home-modules-offers',
          subTitle: 'views-home-modules-offers-more',
          showDesc2: true,
          // useHomePageSize: true,
          cardItemStyle: {
            width: '25%',
          },
          cards: [],
          index: 'offer',
        },
      };
    },

    methods: {
      // 点击首页benefit，offer去往详情页
      goToBenefitDetail(data) {
        const { kind, vmorcId } = data;
        kind === 2 && this.$router.push({ path: '/benefit/details', query: { vmorcId } });
      },
      // 点击首页offer去往详情页
      goToOfferDetail(data) {
        const { kind, vmorcId } = data;
        kind === 1 && this.$router.push({ path: '/offer/details', query: { vmorcId } });
      },
      // 卡片的view More被点击
      handleViewMore(data) {
        const lounges = data.includes('lounge');
        const dining = data.includes('dining');
        const retail = data.includes('retail');
        const benefits = data.includes('Benefit');
        const offers = data.includes('Offer');
        if (lounges) this.$router.push({ path: '/lounges' });
        if (dining) this.$router.push({ path: '/dining' });
        if (retail) this.$router.push({ path: '/retail' });
        if (benefits) this.$router.push({ name: 'Visabenefits' });
        if (offers) this.$router.push({ name: 'Visaoffers' });
      },

      // 获取bennefit banner图
      async getHomePageBanner(data) {
        const { userId = '', sessionId = '' } = this.userInfo;
        const lang = this.$i18n.locale;
        const res = await this.$http.common.getHomePageBanner({ ...data, userId, sessionId, lang });
        if (res.state === '11') {
          if (data.type === 'benefits') {
            this.benefits.cards = res.payload.slice(0, 3);
          }
          if (data.type === 'offers') {
            this.offers.cards = res.payload.slice(0, 3);
          }
        } else {
          console.error(res.note);
        }
      },

      getBenefitsList() {
        this.$loading.show();
        const params = {
          userId: this.userInfo?.userId ?? '',
          lang: this.$i18n.locale,
        }
        this.$http.lounge.getBenefitsList(params).then(res => {
          if (res.state === '11') {
            this.lounge.cards = res.payload.lounges.slice(0, 3);
            this.dining.cards = res.payload.dining.slice(0, 3);
            this.retail.cards = res.payload.retail.slice(0, 3);
          } else {
            console.error(res.note);
          }
        });
      },
      cardClick(data) {
        console.log('data', data);
        if (data.productType === 1) {
          this.$router.push({
            path: '/lounge/details',
            query: { loungeCode: data.code },
          });
        } else if (data.productType === 2) {
          this.$router.push({
            path: '/dining/details',
            query: { diningCode: data.code },
          });
        } else if (data.productType === 3) {
          this.$router.push({
            path: '/retail/details',
            query: { airportCode: data.airportCode, retailCodes: data.code },
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index.scss';
  @import './mobile';
</style>
